import React from "react";
import Image from "components/image";
import Link from "components/link";
import { trackNavClick } from "analytics";

const BannerImage = ({ data }) => (
	<div className="relative">
		<Link to={data?.image?.url} onClick={() => trackNavClick(data.title)} data-type="image-link" tabIndex="0">
			<Image image={{ ...data.image, url: null }} alt={data.alt} />
			{data.overlay && <div className="absolute top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50"></div>}
			<div className="absolute top-0 left-0 right-0 bottom-0 flex flex-col justify-center items-center px-10">
				<h2 className="text-white text-xl font-bold">{data.title}</h2>
				<p className="text-white text-base text-center mt-2">{data.subtitle}</p>
			</div>
		</Link>
	</div>
);

export default BannerImage;